(function () {
    'use strict';

    angular.module(modules.homeModule)
           .controller('AboutController', controller);

    controller.$inject = ['$uibModalInstance'];

    function controller($modalInstance) {
        var vm = this;
        vm.translation = {
            about: globalResources.About,
            netpowerHandbook: globalResources.NetpowerHandbook,
            version: globalResources.CommonGridColumns.Version,
            close: globalResources.Close
        };

        vm.applicationVersion = HandbookConfiguration.ApplicationVersion;

        vm.close = close;

        function close() {
            $modalInstance.dismiss('cancel');
        }
    }
})();